 export enum TypeAlerte {
NC = 0,
FinPeriodeEssais = 1,
FinContratCDD = 2,
RappelRenouvellementFormation = 3,
RappelRenouvellementVisiteMedicale = 4,
FinValiditeCarteSejour = 5,
ValidationEntreeSalarie = 6,
EntreeSalarieAValider = 7,
ClotureExercice = 8,
ClotureDSN = 9,
TauxPas = 10,
FinPrevisionnelleCDD = 11,
DpaeARealiser = 12,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/TypeAlerte.ts